import { ComHdmCommercePromoPromotionFetch, RetrieveMultiFreeGiftDetails } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class PromotionDetails<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Get promotion details by catenryId.
	 *
	 * @tags Promotion Details
	 * @name PromotionFetchByCatentryIdDetail
	 * @summary Get promotion details by catenryId.
	 * @request GET:/store/{storeId}/promotionFetch/byCatentryId
	 * @response `200` `ComHdmCommercePromoPromotionFetch` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	promotionFetchByCatentryIdDetail = (
		storeId: string,
		query: {
			/** The catentryId. */
			catentryId: string;
			/** The currentPhysicalStoreId. */
			currentPhysicalStoreId: string;
			/** The currentMarketId. */
			currentMarketId: string;
			/** The profileName. */
			profileName: 'HDM_findDisplayPromotionByCatentryId';
			/** The language ID. */
			langId: string;
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['promotionFetchByCatentryIdDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/promotionFetch/byCatentryId`,
				params: _params,
				query: query,
				methodName: 'promotionFetchByCatentryIdDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<ComHdmCommercePromoPromotionFetch, void>({
			path: `/store/${storeId}/promotionFetch/byCatentryId`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * @description Get Multi Free Gift promotion details for  catenryIds.
	 *
	 * @tags Promotion Details
	 * @name RetrieveMultiFreeGiftDetails
	 * @summary Get Multi Free Gift promotion details for  catenryIds.
	 * @request GET:/store/{storeId}/promotionFetch/retrieveMultiFreeGiftDetails
	 * @response `200` `RetrieveMultiFreeGiftDetails` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	retrieveMultiFreeGiftDetails = (
		storeId: string,
		query: {
			/** The catentryIds. */
			catentryIds: string;
			/** The currentPhysicalStoreId. */
			currentPhysicalStoreId: string;
			/** The language ID. */
			langId: string;
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['retrieveMultiFreeGiftDetails'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/promotionFetch/retrieveMultiFreeGiftDetails`,
				params: _params,
				query: query,
				methodName: 'retrieveMultiFreeGiftDetails',
			};
			logger.trace(traceData);
		}
		return this.http.request<RetrieveMultiFreeGiftDetails, void>({
			path: `/store/${storeId}/promotionFetch/retrieveMultiFreeGiftDetails`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
